"use client"

import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { cn } from "@/lib/utils"

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      {...props}
      ref={ref}
    />
  )
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        // 🔴 Constat PO du 2026-09-19 : « les points centrés dans les boutons radio ne sont
        // pas centrés, on dirait des yeux qui louchent ». DEUX causes, corrigées ensemble —
        // la première seule ne suffisait pas, et le PO l'a revu de travers.
        // ① L'ITEM ne centrait rien : Radix le rend en `<button>`, donc `inline-block`, et son
        //    seul enfant se posait sur la LIGNE DE BASE du texte. Le `flex items-center
        //    justify-center` que portait l'INDICATEUR n'y pouvait rien — il n'a pas de taille
        //    propre dans laquelle centrer. Le centrage appartient à celui des deux qui a une
        //    taille : l'item.
        // ⚠️ Le défaut vient du gabarit d'origine et touche les DOUZE écrans qui montent des
        // radios (portail, éditeur de document, checklists, CRM…), pas seulement celui où il
        // a été vu.
        "flex aspect-square h-4 w-4 items-center justify-center rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      {/* ② Le point n'était PAS un point : c'était l'icône `Circle` de lucide, un cercle
          TRACÉ (`stroke-width: 2` sur un rayon de 10 dans une boîte de 24). Son disque visible
          mesurait donc 9,17 px dans une boîte de 10, et se posait sur des fractions de pixel :
          l'anti-crénelage épaississait un côté, et l'œil lit un point décentré. Un `<span>`
          arrondi n'a ni contour, ni `viewBox`, ni ligne de base — et 8 px dans une boîte de
          contenu de 14 laissent 3 px PLEINS de chaque côté, une marge qui tolère la fraction.
          C'est aussi ce que fait shadcn depuis sa réécriture. */}
      <RadioGroupPrimitive.Indicator className="flex h-full w-full items-center justify-center">
        <span className="h-2 w-2 rounded-full bg-current" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
